package com.schoolconnect.app.designsystem

import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.height
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.SpanStyle
import androidx.compose.ui.text.buildAnnotatedString
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.text.withStyle
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp

@Composable
fun AppLabeledField(
    label: String,
    required: Boolean = false,
    errorText: String = "",
    modifier: Modifier = Modifier,
    verticalSpacing: Dp = 6.dp,
    labelStyle: androidx.compose.ui.text.TextStyle = MaterialTheme.typography.labelMedium,
    labelColor: Color = MaterialTheme.colorScheme.onSurface,
    requiredColor: Color = MaterialTheme.colorScheme.error,
    // Spec: field labels 13 px / 600; helper/error 12 px / 400.
    labelFontWeight: FontWeight = FontWeight.SemiBold,
    errorStyle: androidx.compose.ui.text.TextStyle = MaterialTheme.typography.bodySmall,
    errorColor: Color = MaterialTheme.colorScheme.error,
    errorFontWeight: FontWeight = FontWeight.Normal,
    content: @Composable ColumnScope.() -> Unit
) {
    Column(
        modifier = modifier,
        verticalArrangement = Arrangement.spacedBy(verticalSpacing)
    ) {
        Text(
            text = buildAnnotatedString {
                append(label)
                if (required) {
                    append(" ")
                    withStyle(SpanStyle(color = requiredColor)) {
                        append("*")
                    }
                }
            },
            style = labelStyle,
            color = labelColor,
            fontWeight = labelFontWeight,
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )
        content()
        if (errorText.isNotBlank()) {
            Text(
                text = errorText,
                style = errorStyle,
                color = errorColor,
                fontWeight = errorFontWeight
            )
        } else {
            Spacer(modifier = Modifier.height(0.dp))
        }
    }
}
